import { TableCell, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import useSorting from '../hooks/useSorting';

const DefaultTableBody = ({ rows, columns, sortBy, sortOrder, useStyles, getCellFormat }) => {
  const classes = useStyles();
  const { getColumnSorting } = useSorting();

  const renderSingleRow = row =>
    columns.map(column => {
      const { value, className } = getCellFormat(column.key, row[column.key]);
      return (
        <TableCell key={`${column.key}-${row.id}`}>
          <span className={classes[className]}>{value}</span>
        </TableCell>
      );
    });

  const renderBody = () => {
    const sortedRows = rows.sort(getColumnSorting(sortBy, sortOrder));

    return sortedRows.map(row => (
      <TableRow key={row.id} className={classes.row}>
        {renderSingleRow(row)}
      </TableRow>
    ));
  };

  return renderBody();
};

DefaultTableBody.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  sortBy: PropTypes.string,
  sortOrder: PropTypes.oneOf(['asc', 'desc']),
  styles: PropTypes.shape({}),
  getCellFormat: PropTypes.func
};

DefaultTableBody.defaultProps = {
  sortBy: '',
  sortOrder: 'desc',
  styles: {},
  getCellFormat: () => {}
};

export default DefaultTableBody;
